<div class="grid__cell grid__cell--widget widget__bag" [dragula]='"widget-bag"'>
  <div class="widget__wrap">
    <div class="widget" id="booking-offers-widget">
      <h2 class="widget__header">
        <span class="widget__header__title">
          <i class="widget__header__icon ico-angle-down"></i> Rezervační nabídky</span>
        <span class="widget__header__tools">
          <swb-filter-list (modelChange)="filter($event)"></swb-filter-list>
          <a [routerLink]="['add']" class="cta cta--small cta--green">
            <span class="cta__light">Přidat</span> nabídku
            <i class="ico-plus"></i>
          </a>
        </span>
      </h2>
      <div class="widget__content">
        <swb-booking-offer-list [query]="query"></swb-booking-offer-list>
      </div>
    </div>
  </div>
  <div class="widget__wrap">
    <div class="widget" id="booking-holidays-widget">
      <h2 class="widget__header">
        <span class="widget__header__title">
          <i class="widget__header__icon ico-angle-down"></i> Rezervační prázdniny</span>
        <span class="widget__header__tools">
          <a [routerLink]="['holidays/add']" class="cta cta--small cta--green">
            <span class="cta__light">Přidat</span> prázdniny
            <i class="ico-plus"></i>
          </a>
        </span>
      </h2>
      <div class="widget__content">
        <swb-booking-holiday-list></swb-booking-holiday-list>
      </div>
    </div>
  </div>
</div>
<div class="grid__cell grid__cell--widget widget__bag" [dragula]='"widget-bag"'>
  <div class="widget__wrap">
    <div class="widget" id="booking-items-widget">
      <h2 class="widget__header">
        <span class="widget__header__title">
          <i class="widget__header__icon ico-angle-down"></i> Nabídkové položky</span>
        <span class="widget__header__tools">
          <swb-filter-list (modelChange)="filterItems($event)"></swb-filter-list>
          <a [routerLink]="['items/add']" class="cta cta--small cta--green">
            <span class="cta__light">Přidat</span> položku
            <i class="ico-plus"></i>
          </a>
        </span>
      </h2>
      <div class="widget__content">
        <swb-booking-items-list [query]="itemQuery"></swb-booking-items-list>
      </div>
    </div>
  </div>
</div>
<router-outlet></router-outlet>
